import * as React from 'react';
import { Tooltip } from '@mui/material';
import { ReactComponent as AiGemSvg } from '~/src/static/ai-gem-icon.svg';

type AiGemIconProps = {
  className?: string;
  width?: number;
  height?: number;
  tooltipText?: string;
};

export const AiGemIcon = ({
  className = '',
  width = 20,
  height = 20,
  tooltipText = 'Powered by AI',
}: AiGemIconProps) => {
  return (
    <Tooltip title={tooltipText} placement="top">
      <span>
        <AiGemSvg className={className} width={width} height={height} />
      </span>
    </Tooltip>
  );
};
